import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormErrorComponent } from '@ui-kit/form/form-error/form-error.component';
import { FormLabelComponent } from '@ui-kit/form/form-label/form-label.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'dropdown-fc',
    standalone: true,
    imports: [
        FormLabelComponent,
        FormErrorComponent,
        TranslateModule,
        SelectModule,
        ReactiveFormsModule,
        MultiSelectModule,
    ],
    templateUrl: './dropdown-fc.component.html',
    styleUrl: './dropdown-fc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownFcComponent {
    private translate = inject(TranslateService);

    id = input.required<string>();
    control = input.required<FormControl>();
    options = input.required<any[]>();

    multiple = input<boolean>(false);
    editable = input<boolean>(false);

    optionLabel = input<string | undefined>('text');
    optionValue = input<string | undefined>('value');
    optionDisabled = input<string | undefined>(undefined);

    label = input<string>('');
    tooltipText = input<string>('');
    infoTooltipClass = input<string>('fa-regular fa-circle-question');
    required = input<boolean>(false);
    showClear = input<boolean>(true);
    filter = input<boolean>(true);
    filterBy = input<string | null>(null);

    size = input<'small' | 'large'>('large');
    fluid = input<boolean>(true);

    placeholder = input<string>('uiKit.form.dropdown.placeholder');
    emptyMessage = input<string>('');
    name = input<string>(''); //used for validation messages, if there is no label

    appendTo = input<string>('body');

    onChange = output<void>();

    readonly errorMessages: Record<string, (label: string, control: FormControl, error: any) => string> = {
        required: () => `${this.translate.instant('uiKit.form.dropdown-fc.emptySelectFormValidator')}`,
    };

    getErrorMessage(error: string): string {
        const label = this.label() ? this.label() : this.name();

        return this.errorMessages[error]
            ? this.errorMessages[error](label, this.control(), this.control().errors && this.control().errors?.[error])
            : '';
    }

    getErrorKeys(errors: ValidationErrors | null): string[] {
        return errors ? Object.keys(errors) : [];
    }
}
